import React from 'react';
import { Row , Col , ProgressBar , Button } from 'react-bootstrap';
import moment from 'moment';
import GeneratePDF from '../../../classes/pdf_generate.js';
import Translation from '../../../store/internationalization-store.js';

class FormattedMessage extends React.Component {
    constructor(props) {
        super();
        this.props = props;
    }

    render(){
        return <span>{Translation.get(this.props.id , this.props.defaultMessage)}</span>
    }
}


class SavePrintable extends React.Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.state = { saved: false};
        this.PDFgen = new GeneratePDF();
    }

    componentDidMount() {
        var vocabs = this.props.data.selectedVocab || [];
        var printable = this.props.data.printable;
        var language = this.props.data.selectedLanguage;
        var level = this.props.data.level;

        switch (printable) {
             case "Word Search":

                 console.log(vocabs);
                this.PDFgen.generateWordSearch(vocabs, language, level).then(function(){
                    var ctx = document.getElementById("canvasPdf");
                    if (ctx != undefined && ctx != null) {
                        ctx.parentElement.removeChild(ctx);
                    }

                    window.location.hash = 'library/printables'
                    this.setState({
                        saved:true
                    })
                }.bind(this));

                break;
            case "Snap":
                this.PDFgen.generateSnapPDF(vocabs, language).then(function(){
                    var ctx = document.getElementById("canvasPdf");
                    if (ctx != undefined && ctx != null) {
                        ctx.parentElement.removeChild(ctx);
                    }
                    window.location.hash = 'library/printables'
                    this.setState({
                        saved:true
                    })
                }.bind(this));
                break;
            case "Flashcards":
                this.PDFgen.generateFlashcardPDF(vocabs, language).then(function(){
                    var ctx = document.getElementById("canvasPdf");
                    if (ctx != undefined && ctx != null) {
                        ctx.parentElement.removeChild(ctx);
                    }
                    window.location.hash = 'library/printables'
                    this.setState({
                        saved:true
                    })
                }.bind(this));
                break;
            case "Dice":
                this.PDFgen.generateDicePDF(vocabs, language).then(function(){
                    var ctx = document.getElementById("canvasPdf");
                    if (ctx != undefined && ctx != null) {
                        ctx.parentElement.removeChild(ctx);
                    }
                    window.location.hash = 'library/printables'
                    this.setState({
                        saved:true
                    })
                }.bind(this));
                break;
            case "Vocab List":
            default:
                this.PDFgen.generateVocabPDF(vocabs, language).then(function(){
                    var ctx = document.getElementById("canvasPdf");
                    if (ctx != undefined && ctx != null) {
                        ctx.parentElement.removeChild(ctx);
                    }
                    window.location.hash = 'library/printables'
                    this.setState({
                        saved:true
                    })
                }.bind(this));
                break;
        }
    }

    renderSaving(){

        if(this.state.saved) return <div>
            <center><h5>Download completed</h5></center>
            <br/>
            <center> <Button onClick={this.props.reset}>Make another printable</Button></center>
        </div>
        return <ProgressBar animated now={45} />
    }

    renderSaved(){
        return <div></div>
    }

    render(){
         return this.renderSaving()
    }
}


export default {
    name: <FormattedMessage id={ 'ui-336' } defaultMessage={ 'Save' }/>,
    onSubmit: function (done){
        done();
    },
    component: SavePrintable
}